import React from 'react';
import {Link} from 'react-router-dom';
import RecoveryTreeLogo from './RecoveryTreeLogo';
import site from '../../data/site';

const Footer = () => (
    <footer className="sw-footer">
        <div className="sw-container sw-footer__inner">
            <div className="sw-footer__col">
                <div className="sw-footer__brand">
                    <RecoveryTreeLogo width={36} height={40}/>
                    <div>
                        <p className="sw-footer__brand-name">STRATEGIC WELLNESS</p>
                        <p className="sw-footer__brand-sub">ADVOCATES LLC</p>
                    </div>
                </div>
                <p className="sw-footer__line">{site.location}</p>
                <p className="sw-footer__line">{site.officeHoursShort}</p>
                <a className="sw-footer__link" href={`mailto:${site.email}`}>{site.email}</a>
            </div>
            <div className="sw-footer__col">
                <p className="sw-footer__col-title">Visit</p>
                <address className="sw-footer__address">
                    {site.address.lines.map((line) => (
                        <React.Fragment key={line}>{line}<br/></React.Fragment>
                    ))}
                </address>
                <a className="sw-footer__link" href={site.address.mapsUrl} target="_blank" rel="noopener noreferrer">
                    View directions
                </a>
            </div>
            <div className="sw-footer__col">
                <p className="sw-footer__col-title">Call</p>
                {site.phones.map((phone) => (
                    <a key={phone.href} className="sw-footer__link" href={phone.href}>{phone.label}</a>
                ))}
                <p className="sw-footer__line">Fax: {site.fax}</p>
            </div>
            <div className="sw-footer__col">
                <p className="sw-footer__col-title">Follow</p>
                {site.socials.map((social) => (
                    <a key={social.label} className="sw-footer__link" href={social.url}
                       target="_blank" rel="noopener noreferrer">{social.label}</a>
                ))}
            </div>
        </div>
        <div className="sw-container sw-footer__bottom">
            <p>© {new Date().getFullYear()} {site.name}. All Rights Reserved.</p>
            <div className="sw-footer__legal">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/terms-and-conditions">Terms and Conditions</Link>
            </div>
        </div>
    </footer>
);

export default Footer;
